export default [
  {
    title: "바닥 및 통로",
    list: [
      {
        content: "1. 넘어지거나 미끄러지는 등 위험이 없도록 작업장 바닥 등을 안전하고 청결한 상태로 유지하고 있다.",
        isChecked: "",
      },
      {
        content: "2. 바닥 이음매(그라우팅)는 기름기, 산·알칼리 용제 및 물에 대한 저항성이 있는 재료*가 사용되었다.\n* 에폭시, 실리콘, 폴리우레탄 수지 및 시멘트풀 등",
        isChecked: "",
      },
      {
        content: "3. 바닥에 물이 유출되거나 바닥을 물로 청소하는 전처리실, 조리실, 세척실 등에 배수로가 설치되어 있다.",
        isChecked: "",
      },
      {
        content: "4. 물이나 그 밖의 액체를 사용하여 세척 및 소독하는 곳의 바닥은 배수구쪽으로 경사지게 하고, 막힘이나 역류하지 않도록 조치하고 있다.",
        isChecked: "",
      },
      {
        content: "5. 5kg 이상의 중량물 취급 및 보관장소에 중량물 취급주의와 무게중심 표지를 부착하였다.",
        isChecked: "",
      },
      {
        content: "6. 청소 시 발생한 오물 처리를 위한 장소를 지정하였다.",
        isChecked: "",
      },
      {
        content: "7. 작업장에는 “바닥 미끄럼주의”, “미끄럼방지화 착용” 등 표지를 부착하였다.",
        isChecked: "",
      },
      {
        content: "8. 작업장에 적정한 조도의 조명기구가 설치되어 있다.",
        isChecked: "",
      },
      {
        content: "9. 작업장에 비상시 탈출할 수 있는 비상구를 설치하였다.",
        isChecked: "",
      }, {
        content: "10. 근로자의 눈에 띄기 쉬운 곳에 비상구임을 알아볼 수 있는 표시가 부착되어 있다.",
        isChecked: "",
      },
      {
        content: "11. 화재에 대비한 소화시설이 갖추어져 있다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "사다리",
    list: [
      {
        content: "1. 이동식사다리 사용 시 이동통로용 사다리(일자형)와 작업용 사다리(발붙임, A형)를 구분하여 사용한다.",
        isChecked: "",
      },
      {
        content: "2. 작업을 시작하기 전에 사다리 기둥, 작업 발판의 상태를 확인한다.",
        isChecked: "",
      },
      {
        content: "3. 사다리 작업시 2인 1조로 작업한다.",
        isChecked: "",
      },
      {
        content: "4. 사다리 상단은 걸쳐놓은 지점으로부터 60cm 이상 올라가는 등 적정한 길이의 사다리를 사용한다.",
        isChecked: "",
      },
      {
        content: "5. 벌어짐 방지장치, 발판 미끄럼 방지 고무패드가 장착된 사다리를 사용한다.",
        isChecked: "",
      },
      {
        content: "6. 사다리의 넘어짐·미끄러짐을 방지하기 위해 평탄하고 견고한 지반 또는 바닥에 설치한다.",
        isChecked: "",
      },
      {
        content: "7. 바닥과 사다리는 가능한 한 수평을 유지하여 작업한다.",
        isChecked: "",
      },
      {
        content: "8. 짧은 사다리 길이를 늘이기 위해 겹쳐 이어 사용하지 않는다.",
        isChecked: "",
      },
      {
        content: "9. 사다리의 사용 높이를 임의로 높이기 위해 상자, 리프트, 그 밖에 불안정한 곳에 설치하지 않는다.",
        isChecked: "",
      },
      {
        content: "10. 보행자 통행로, 차량 도로, 문이 열리는 곳 등에서 작업할 때 사다리와의 충돌 가능성을 확인한다.",
        isChecked: "",
      },
      {
        content: "11. 금속사다리의 경우 내부식성 재료로 만들어졌거나 부식방지 조치가 되어 있다.",
        isChecked: "",
      },
      {
        content: "12. 작업 전 사다리 주위 전선, 전기설비 등 감전위험을 확인하여 안전거리를 확보하고, 부도체 재질의 사다리를 사용한다.",
        isChecked: "",
      },
      {
        content: "13. 떨어질 위험이 있는 사다리 작업시 안전모(턱끈 조임) 등 개인보호구를 착용하고 작업한다.",
        isChecked: "",
      },
      {
        content: "14. 작업자는 균형을 잃거나 추락의 가능성이 있는 무거운 짐이나 장비를 들고 사다리를 오르내리지 않는다.",
        isChecked: "",
      },
      {
        content: "15. 사다리 작업 시 하중이 사다리의 최대 설계하중을 넘지 않도록 준수한다.",
        isChecked: "",
      },
      {
        content: "16. 사다리에 기름과 유지 등이 묻었다면 해당 물질을 용제 또는 물 세척으로 제거한다.",
        isChecked: "",
      },
      {
        content: "17. 사다리는 수시로 점검하고, 결함이 있는 것들은 수리나 재구매를 하는 등 관리를 하고 있다.",
        isChecked: "",
      },
    ],
  },
];
